import { useEffect, useState } from 'react';
import useEspial from './useEspial';
import { EspialEventTypes } from '../../../../types/Espial/EspialEventTypes';

const useSendEspialCheckoutFunnelEventOnce = (
  params: Record<string, any>[],
  dependencies?: any[],
  onComplete?: () => void,
  onError?: (error: any) => void,
) => {
  const { trackEvent } = useEspial();
  const [tagIsSent, setTagIsSent] = useState(false);

  useEffect(() => {
    if (!tagIsSent && params?.length > 0) {
      try {
        trackEvent(EspialEventTypes.CHECKOUT_FUNNEL, params);
        setTagIsSent(true);
        if (onComplete) onComplete();
      } catch (error) {
        if (onError) onError(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagIsSent, params, trackEvent, ...(dependencies || [])]);
};

export default useSendEspialCheckoutFunnelEventOnce;
